/* eslint-disable babel/no-invalid-this */
/* eslint-disable babel/camelcase */
/* eslint-disable no-undef */

// The foil rainbow (advanced-search.scss) is painted on tilt.js's injected .js-tilt-glare
// overlay — a foiled card only shimmers once that element exists inside its image wrap.
function initCardFoilEffects()
{
  const targets = $('.productCard__imageWrap').filter(function ()
  {
    return !this.querySelector('.js-tilt-glare')
  })
  if (!targets.length || !$.fn.tilt)
  {
    return
  }
  targets.tilt({
    perspective: 2000,
    maxGlare: 0.6,
    glare: true,
    speed: 500,
    scale: 1.01
  })
}

$(document).ready(() =>
{
  initCardFoilEffects()

  // CloudSearch filtering re-renders the results via innerHTML, which drops tilt's glare
  // elements and never re-runs tilt — watch for injected cards and re-init (cheap no-op
  // when nothing new; already-inited wraps are filtered out by the .js-tilt-glare check).
  new MutationObserver(() =>
  {
    initCardFoilEffects()
  }).observe(document.body, { childList: true, subtree: true })
})

const variableElement = $('#search-template-js')
const _COLLECTION = variableElement.attr('data-collection')
const COLLECTION = _COLLECTION === 'null' ? null : JSON.parse(_COLLECTION)
const ADD_TO_CART = variableElement.attr('data-add-to-cart')
const SOLD_OUT = variableElement.attr('data-sold-out')
const PREORDER = variableElement.attr('data-preorder')

const getVariantStatus = (variant, product, collection) =>
{
  let status
  if (variant.available === false)
  {
    status = SOLD_OUT
  }
  else if (
    collection?.title.includes('pre-order')
    || collection?.title.includes('preorder')
    || product.collectionsTitles.some(title => title.includes('pre-order'))
    || product.collectionsTitles.some(title => title.includes('preorder'))
    || product.tags.includes('preorder')
  )
  {
    status = PREORDER
  }
  else if (
    product.type !== 'Event Ticket' && variant.quantity <= 0 && variant.inventory_policy === 'continue'
  )
  {
    status = 'Back-order'
  }
  else
  {
    status = ADD_TO_CART
  }
  return status
}

const variantSelect = (productId, variantId) =>
{
  const productElement = document.querySelector(`.productCard__card[data-productid="${productId}"]`)
  const productCtaBtn = productElement.querySelector('.product-item__action-button')
  const productTags = JSON.parse(productElement.getAttribute('data-productTags'))
  const productCollectionsTitles = JSON.parse(productElement.getAttribute('data-productCollectionsTitles'))
  const productType = productElement.getAttribute('data-productType')
  const productFormInput = productElement.querySelector('input[name="id"]')

  const allVariantElements = productElement.querySelectorAll('li')
  const selectedVariantElement = productElement.querySelector(`li[data-variantid="${variantId}"]`)
  const selectedVariantTitle = selectedVariantElement.getAttribute('data-variantTitle')
  const selectedVariantAvailable = (selectedVariantElement.getAttribute('data-variantAvailable') === 'true')
  const selectedVariantQty = selectedVariantElement.getAttribute('data-variantQty')
  const selectedVariantPolicy = selectedVariantElement.getAttribute('data-variantPolicy')
  const selectedVariantPrice = selectedVariantElement.getAttribute('data-variantPrice')

  productFormInput.value = variantId

  const productBtnText = getVariantStatus(
    {
      available: selectedVariantAvailable,
      quantity: selectedVariantQty,
      inventory_policy: selectedVariantPolicy
    },
    {
      tags: productTags,
      type: productType,
      collectionsTitles: productCollectionsTitles
    },
    COLLECTION
  )

  productCtaBtn.innerText = productBtnText

  if (productBtnText === 'Sold out')
  {
    productCtaBtn.classList.remove('button--primary')
    productCtaBtn.classList.add('productCard__button--outOfStock')
  }
  else
  {
    productCtaBtn.classList.add('button--primary')
    productCtaBtn.classList.remove('productCard__button--outOfStock')
  }

  allVariantElements.forEach((variant) =>
  {
    if (variant.getAttribute('data-variantid') == variantId)
    {
      variant.classList.add('productChip__active')
      if (selectedVariantTitle.includes('Foil'))
      {
        productElement.classList.add('foiled')
      }
      else
      {
        productElement.classList.remove('foiled')
      }
    }
    else
    {
      variant.classList.remove('productChip__active')
    }
  })

  const productPrice = productElement.querySelector('.productCard__price')
  productPrice.innerHTML = Shopify.formatMoney(selectedVariantPrice, window.theme.moneyWithCurrencyFormat)

  const activeProductImage = productElement.querySelector('.productCard__img.active')
  if (activeProductImage.getAttribute('data-variant-id') != variantId)
  {
    activeProductImage.classList.toggle('active')
  }

  const selectedVariantImage = productElement.querySelector(`.productCard__img[data-variant-id="${variantId}"]`)
  selectedVariantImage.classList.toggle('active', true)
}

const addToCartBtn = (id) =>
{
  const btn = document.querySelector(`.productCard__button[data-selectedId='${id}']`)
  const itemTitle = btn.getAttribute('data-selectedProductTitle')
  const maxStock = btn.getAttribute('data-selectedMax')
  const variantTitle = btn.getAttribute('data-selectedVariantTitle')
  btn.parentNode.querySelector('input[name="id"]').value = id
  addToCart(id, itemTitle, maxStock, 1, variantTitle)
}
